module.exports = __webpack_public_path__ + "static/media/waterheater.e207d8b2.jpg";